/* global $:false */
(function() {
  'use strict';

  angular
    .module('admin.explore.customset', [
      'admin.explore.customset.service'
    ])
    .controller('ExploreCustomSetCtrl', ExploreCustomSetCtrl);

  /** @ngInject */
  function ExploreCustomSetCtrl($scope, $state, $stateParams, $q, $timeout, UserSegmentationService, ExploreCustomSetService,
    EventService) {
    var vm = this;
    vm.readyOnly = false;
    vm.items = [];
    vm.channels = [];
    vm.sets = [];
    vm.waitChannel = true;
    vm.parentId = $stateParams.id;

    vm.usersPerPage = 10;

    function reloadPagination(){
      vm.totalUsers = 0;
      vm.oldPage = 0;
      vm.currentPage = 10;
      vm.first = true;
      vm.totalItems = 0;
      vm.pagination = {
        current: 1
      };
    }

    reloadPagination();

    load(1);

    function load(pageNumber){
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 10;
        vm.oldPage = vm.currentPage - 10;
      }
      else {
        vm.first = false;
      }

      ExploreCustomSetService.listSlss(vm.parentId, vm.oldPage, 10).then(function(result){
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }

        var items = result.results;
        for (var i = 0; i < items.length; i++) {
          if (pageNumber === 1 && i === 0) {
            items[i].firstRow = true;
          }

          if ((items.length-1) === i && items.length < vm.currentPage) {
            items[i].lastRow = true;
          }
          items[i].edit = false;
        }

        vm.items = items;
      });

      EventService.listChannels().then(function(result){
        vm.channels = result.results;
      });
    }

    vm.add = function(){
      var isPass = true;
      vm.readyOnly = true;
      vm.items.map(function(item){
        if (item.id === 0) {
          swal('You have a row empty fill it first', '', 'warning');
          isPass = false;
          return;
        }
      });
      if (isPass) {
        vm.items.unshift({
          id: 0,
          'id-ch': null,
          'id-s': null,
          edit: true,
        });
      }
    };

    vm.edit = function(item){
      var channel = _.find(vm.channels, {'id': item.s['id-ch']});
      vm.channelId = channel.id;
      vm.readyOnly = true;

      EventService.listSets(item.s['id-ch']).then(function(response){
        vm.sets = response.results;
        vm.setId = item.s.id;
        item.edit = !item.edit;
        vm.waitChannel = false;
      });
    };

    vm.save = function(item){
      if (vm.channelId === undefined || vm.channelId === null || vm.channelId === '') {
        swal('You need add channel id field', '', 'warning');
        return;
      }

      if (vm.setId === undefined || vm.setId === null || vm.setId === '') {
        swal('You need add set id field', '', 'warning');
        return;
      }

      var newRow = {
        'id-sl': parseInt(vm.parentId),
        'id-s': vm.setId,
      };

      if (item.id === 0) {
        ExploreCustomSetService.createSlss(vm.parentId, newRow).then(function(){
          vm.waitChannel = true;
          vm.channelId = null;
          vm.setId = null;
          vm.readyOnly = false;
          if (vm.items.length === 11) {
            $state.reload();
          } else {
            load(vm.pagination.current);
          }
        });
      } else {
        ExploreCustomSetService.updateSlss(vm.parentId, item.id, newRow).then(function(){
          vm.waitChannel = true;
          vm.channelId = null;
          vm.setId = null;
          vm.readyOnly = false;
          if (vm.items.length === 11) {
            $state.reload();
          } else {
            load(vm.pagination.current);
          }
        });
      }
    };

    vm.cancel = function(item){
      swal({
        title: "Are you sure?",
        text: "",
        type: "warning",
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: "slide-from-top"
      }, function(isConfirm){
        if (isConfirm){
          vm.readyOnly = false;
          if (item.id === 0) {
            vm.items.remove(item);
          } else {
            item.edit = !item.edit;
          }
          $scope.$apply();
        } else {
          return;
        }
      });
    };

    vm.delete = function(item){
      swal({
        title: "Are you sure?",
        text: "",
        type: "warning",
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: "slide-from-top"
      }, function(isConfirm){
        if (isConfirm){
          $timeout(function(){
            ExploreCustomSetService.removeSlss(vm.parentId, item.id).then(function(){
              vm.readyOnly = false;
              if (vm.items.length === 1 || vm.items.length === 10) {
                $state.reload();
              } else {
                load(vm.pagination.current);
              }
            }, function(err) {
              vm.readyOnly = false;
              swal(err.error.message, '', 'error');
            });
          }, 250);
        } else {
          return;
        }
      });
    };

    vm.arrowUp = function(item){
      if (item.edit) {
        return;
      }
      var copy = angular.copy(item);
      copy.n = copy.n - 1;
      ExploreCustomSetService.updateSlss(vm.parentId, copy.id, {n: copy.n}).then(function(){
        load(vm.pagination.current);
      });
    };

    vm.arrowDown = function(item){
      if (item.edit) {
        return;
      }
      var copy = angular.copy(item);
      copy.n = copy.n + 1;
      ExploreCustomSetService.updateSlss(vm.parentId, copy.id, {n: copy.n}).then(function(){
        load(vm.pagination.current);
      });
    };

    vm.loadSet = function(id){
      vm.waitChannel = true;
      EventService.listSets(id).then(function(response){
        vm.sets = response.results;
        vm.waitChannel = false;
      });
    };

    vm.pageChanged = function(newPage) {
      load(newPage);
    };
  }

})();
